<template>
  <b-overlay
  :show="loading"
  rounded="lg">
    <b-card title="Delivery Picking Process">
      <b-col cols="4">
        <b-button variant="primary" :to="{ name: 'ongoing-delivery-picking' }" size="sm">
          <feather-icon size="1x" icon="ArrowLeftIcon" /> Back to Ongoing Delivery Picking
        </b-button>
      </b-col>
      <br />
      <b-col cols="12">
        <b-row>
          <b-col cols="12" style="margin-top:10px">
            <div class="mb-2" v-for="(item, index) in header" :key="index">
              <b-row :key="'so-'+index">
                <b-col cols="4"><strong>SO Number</strong></b-col>
                <b-col>: {{ item.orderNumber }}</b-col>
              </b-row>
              <b-row :key="'date-'+index">
                <b-col cols="4"><strong>Order Date</strong></b-col>
                <b-col>: {{ item.createdAt }}</b-col>
              </b-row>
              <b-row :key="'addr1-'+index">
                <b-col cols="4"><strong>Delivery Address 1</strong></b-col>
                <b-col>: {{ item.deliveryAddressOne }}</b-col>
              </b-row>
              <b-row :key="'addr2-'+index">
                <b-col cols="4"><strong>Delivery Address 2</strong></b-col>
                <b-col>: {{ item.deliveryAddressTwo }}</b-col>
              </b-row>
            </div>
            <b-row>
              <b-col cols="4"><strong>Selected Picklist</strong></b-col>
              <b-col v-if="selectedPicklist.length > 0">: {{selectedPicklist.map((p)=> p.picklistNumber).join(', ')}}</b-col>
              <b-col v-else>: -</b-col>
            </b-row>
            <br>
            <b-row class="mt-2 mb-1">              
              <b-col cols="6">
              </b-col>
              <b-col cols="6" style="display: flex; justify-content: space-between;">
                <b-col cols="4">
                  <div style="display: flex; align-items: center;">
                  <span style="margin-right: 10px; white-space: nowrap; font-size: 16px;">Select All picklist C</span>
                  <b-form-checkbox v-model="selectedAllPicklistC" />
                  </div>
                </b-col>
                <b-col cols="4">
                  <div style="display: flex; align-items: center;">
                    <span style="margin-right: 10px; white-space: nowrap; font-size: 16px;">Select All picklist S</span>
                    <b-form-checkbox v-model="selectedAllPicklistS" />
                  </div>
                </b-col>
                <b-col cols="4">
                  <div style="display: flex; justify-content: flex-end;">
                    <b-button :disabled="selectedPicklist.length === 0" @click="processDelivery" class="mr-2" variant="success">
                      Process
                    </b-button>
                  </div>
                </b-col>
              </b-col>
            </b-row>
            <b-table
              :items="delivery"
              :fields="fieldPicklist"
              responsive="xl"
              hover
              head-variant="dark"
              outlined
              small
              class="table-responsive"
              sticky-header
            >
              <template v-slot:cell(select)="row">
                <b-form-checkbox
                v-if="!(row.item.pickListType == 'C' && row.item.props.statusNo != 55) && !(row.item.props.DPS != undefined)"
                :value="row.item"
                v-model="selectedPicklist"
                :disabled="disableButtonSelectPicklist"
                /> 
              </template>
              <template v-slot:cell(action)="row">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="openPDF(row.item)"
                  style="margin-right:10px">
                  View Pdf
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
      <br />
    </b-card>
  </b-overlay>
</template>
  
<script>
  import { dateFormat} from "@/utils/utils.js";
  import { mapActions } from "vuex";

  export default {
    props: ["sonumber"],
    data() {
      return {
        fieldPicklist: [
          {
            key: "picklistNumber",
            label: "Pick List Number",
            filterable: true,
            sortable: false,
          },
          {
            key: "lineItem",
            label: "Line Item",
            filterable: true,
            sortable: false,
          },
          {
            key: "lineDescription",
            label: "Line Description",
            filterable: true,
            sortable: false,
          },
          {
            key: "fromBatch",
            label: "Drum Number",
            filterable: true,
            sortable: false,
          },
          {
            key: "pickListType",
            label: "Pick List Type",
            filterable: true,
            sortable: false,
          },
          {
            key: "quantity",
            label: "Quantity",
            filterable: true,
            sortable: false,
          },
          {
            key: "unit",
            label: "Unit",
            filterable: true,
            sortable: false,
          },
          {
            key: "binLocation",
            label: "Bin Location",
            filterable: true,
            sortable: false,
          },
          {
            key: "props.statusNo",
            label: "Status",
            filterable: true,
            sortable: false,
          },
          {
            key: "cableLengthInfo",
            label: "Cable Length",
            filterable: true,
            sortable: false,
          },
          {
            key: "cableWeight",
            label: "Cable Weight",
            filterable: true,
            sortable: false,
          },
          {
            key: "machineName",
            label: "Machine",
            filterable: true,
            sortable: false,
          },
          {
            key: "user",
            label: "Cutter",
            filterable: true,
            sortable: false,
          },
          {
            key: "statusDelivery",
            label: "Status Delivery",
            filterable: true,
            sortable: false,
          },
          { key: "select", label: "Select"},
          { key: "action", label: "Action"}

        ],
        selectedPicklist: [],
        disableButtonSelectPicklist : false,
        selectedAllPicklistC : false,
        selectedAllPicklistS : false,
        deliveryStarted: false,
        allDeliveryDone: false,
        disablePick: true,
        startTimer : null,
        totalTimer : "",
        ongoingDelivery : "",
        loading : false,
        intervalFetch : null,
        header: [
          {
            orderNumber: '',
            createdAt: '',
            deliveryAddressOne: '',
            deliveryAddressTwo: ''
          }
        ]
      };
    },

    methods: {
      ...mapActions({
        getPicklist: "picklist/getPicklist",
      }),
      openPDF(data) {
        if (data.pdfURL) {
          window.open(data.pdfURL, '_blank')
        }else{
          this.$bvToast.toast("No PDF available", {
            title: "No PDF available",
            variant: "danger",
            solid: true,
          });
        }
      },
      processDelivery() {
        const payload = {
          listOrderNumber: this.selectedPicklist.map(el => el.orderNumber),
          item: this.selectedPicklist.map(el => ({
            picklist: el.id,
            orderNumber: el.orderNumber
          }))
        }

        this.$store.dispatch("delivery/createDelivery", payload)
        .then((res) => {
          this.$bvToast.toast("Created Delivery Order success.", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          setTimeout(() => {
            this.$router.push({
              name: 'ongoing-delivery-picking',
            });
          }, 2000);
        })
        .catch((e) => {
          this.$bvToast.toast("Created Delivery Order failed.", {
            title: "Warning",
            variant: "danger",
            solid: true,
          });
        })
      },
      async fetchData(){
        const orderNumbers = Array.isArray(this.sonumber) ? this.sonumber : [this.sonumber];
        await this.$store.dispatch("picklist/getPicklistDelivery", {
            orderNumber: orderNumbers
        }).then((res) => {
          this.header = res.header
        }).catch((e) => {
          this.$bvToast.toast("Load data failed, please reload the page.", {
            title: "Warning",
            variant: "danger",
            solid: true,
          });
          console.error(e);
        })
      }
    },
    created() {
      document.title = "Delivery Picking Process | Tai Sin";
    },
    computed: {
      delivery() {
        let delivery = this.$store.getters["picklist/getPicklistDelivery"].filter(el => el.pickListType != "R").map(el => {
          var newOrderDate = dateFormat(el.orderDate).split(",")
          var statusDelivery;
          if((el.pickListType == "C" && el.props.statusNo != 55)){
            statusDelivery = "Not Ready"
          }else{
            if(el.props.DPS == undefined){
              statusDelivery = "Ready to Deliver"
            }else if(el.props.DPS != undefined && el.props.DPE == undefined){
              statusDelivery = "Ongoing Delivery"
            } else {
              statusDelivery = "Delivery Finished"
            }
          }
          return {
            ...el,
            orderDate : newOrderDate[0] + newOrderDate[1].replace(/\./g, ':'),
            picklistNumber : el.picklistNo + "_" + el.picklistLine,
            machineName : el.pickListType === 'C'? el.props.machineName || 'Not Set Up' : "",
            statusDelivery : statusDelivery
          }
        })
        delivery.sort((a, b) => {
          // Mengurutkan berdasarkan picklistNo secara ascending
          if (a.picklistNo !== b.picklistNo) {
              return a.picklistNo - b.picklistNo;
          } else {
              // Jika picklistNo sama, mengurutkan berdasarkan picklistLine secara ascending
              return a.picklistLine - b.picklistLine;
          }
      });
        
        return delivery;
      },
      orderNumbers() {
        return this.$store.getters["delivery/getOrderNumber"]
      }
    },
    watch: {
      selectedAllPicklistC(value) {
        if (!value) {
          // Jika selectedAllPicklistC false, kosongkan selectedPicklist untuk picklistType "C"
          this.selectedPicklist = this.selectedPicklist.filter(item => item.pickListType !== "C");
        } else if (value && this.selectedAllPicklistS) {
          // Jika keduanya true, pilih semua picklist
          this.selectedPicklist = this.delivery.filter(item => item.statusDelivery == "Ready to Deliver");
        } else {
          // Jika hanya selectedAllPicklistC true, pilih semua picklist dengan pickListType "C" dan Ready to Deliver
          this.selectedPicklist = this.delivery.filter(item => item.pickListType === "C" && item.props.statusNo == 55 && item.statusDelivery == "Ready to Deliver");
        }
        if(!this.deliveryStarted){
          if(this.selectedPicklist != []){
            this.disablePick = false
          }
          if(this.selectedPicklist.length > 0){
            this.disablePick = false
          } else {
            this.disablePick = true
          }
        }
      },
      selectedAllPicklistS(value) {
        if (!value) {
          // Jika selectedAllPicklistS false, kosongkan selectedPicklist untuk picklistType "S"
          this.selectedPicklist = this.selectedPicklist.filter(item => item.pickListType !== "S");
        } else if (value && this.selectedAllPicklistC) {
          // Jika keduanya true, pilih semua picklist
          this.selectedPicklist = this.delivery.filter(item => (item.statusDelivery == "Ready to Deliver"));
        } else {
          // Jika hanya selectedAllPicklistS true, pilih semua picklist dengan pickListType "S"
          this.selectedPicklist = this.delivery.filter(item => item.pickListType === "S"  && item.statusDelivery == "Ready to Deliver");
        }
        if(!this.deliveryStarted){
          if(this.selectedPicklist != []){
            this.disablePick = false
          }
          if(this.selectedPicklist.length > 0){
            this.disablePick = false
          } else {
            this.disablePick = true
          }
        }
      },
      selectedPicklist(item) {
        console.log("this.selectedPicklist", this.selectedPicklist);
        if(!this.deliveryStarted){
          if(this.selectedPicklist != []){
            this.disablePick = false
          }
          if(this.selectedPicklist.length > 0){
            this.disablePick = false
          } else {
            this.disablePick = true
          }
        }
      },
    },
    
    mounted() {
      this.fetchData()
    },
  };
</script>

<style scoped>
.scrollable-table {
  overflow-x: auto;
  width: 100%;
}
</style>
  